<template>
    <div class="">
        <apexchart type="scatter" height="350" :options="chartOptions" :series="series" />
    </div>
</template>

<script>

export default {
    name: "HighSchoolScoreVsCurrentGpaScatter",
    props: ["data"],
    data() {
        return {
            series: [],
            chartOptions: {
                chart: {
                    type: 'scatter',
                    toolbar: { show: false }
                },
                xaxis: {
                    title: { text: "High School Score" },
                    min: 0,
                    max: 100
                },
                yaxis: {
                    title: { text: "Current GPA" },
                    min: 0,
                    max: 4
                },
                markers: {
                    size: 10,
                    colors: [], // We'll populate this dynamically
                },
                tooltip: {
                    shared: false,
                    intersect: true,
                    custom: ({ dataPointIndex }) => {
                        const student = this.data[dataPointIndex];
                        return `
                        <div style="padding: 8px; font-size: 12px; color: #333;">
                            <strong>Name: </strong>${student.name_en}<br/>
                            <strong>Student ID: </strong>${student.student_id}<br/>
                            <strong>Program: </strong>${student.program}<br/>
                            <strong>High School Score: </strong>${student.hs_score}<br/>
                            <strong>Current GPA: </strong>${student.gpa}
                        </div>
                    `;
                    }
                },
            }
        };
    },
    watch: {
        data: {
            handler(newData) {
                if (!Array.isArray(newData) || newData.length === 0) {
                    this.series = [];
                    this.chartOptions.markers.colors = [];
                    return;
                }

                // Calculate min value safely, filtering out invalid values
                const validHsScores = newData
                    .map(d => Number(d.hs_score))
                    .filter(score => !isNaN(score) && score !== null);

                if (validHsScores.length > 0) {
                    this.chartOptions.xaxis.min = Math.min(...validHsScores) - 5;
                }

                // Map GPA to colors
                const markerColors = newData.map(item => {
                    const gpa = Number(item.gpa);
                    if (isNaN(gpa) || gpa === null) return "#718096"; // Gray for invalid
                    if (gpa >= 3.5) return "#38b2ac"; // Green
                    if (gpa >= 3) return "#4299e1";   // Blue
                    if (gpa >= 2) return "#ecc94b";   // Yellow
                    return "#f56565";                  // Red
                });

                // Scatter points
                const scatterPoints = newData
                    .filter(item => {
                        const hsScore = Number(item.hs_score);
                        const gpa = Number(item.gpa);
                        return !isNaN(hsScore) && !isNaN(gpa) && hsScore !== null && gpa !== null;
                    })
                    .map(item => {
                        const gpa = Number(item.gpa);
                        let fillColor = "#718096"; // Default gray for invalid
                        if (!isNaN(gpa)) {
                            fillColor = gpa >= 3.5 ? "#38b2ac" :
                                gpa >= 3 ? "#4299e1" :
                                    gpa >= 2 ? "#ecc94b" :
                                        "#f56565";
                        }
                        return {
                            x: Number(item.hs_score),
                            y: gpa,
                            fillColor: fillColor
                        };
                    });

                this.series = [
                    {
                        name: "Current GPA",
                        data: scatterPoints
                    }
                ];

                this.chartOptions.markers.colors = markerColors;

            },
            immediate: true
        }
    },
};
</script>